import {FC, forwardRef} from 'react';

import IconsMap from './iconsMap';
import {IconProps} from './types';

const Icon: FC<IconProps> = forwardRef(({name, className, onClick, width, color, height}, ref) => {
  const IconComponent = IconsMap[name];

  if (!IconComponent) return null;

  return (
    <IconComponent
      ref={ref}
      className={className}
      onClick={onClick}
      {...(color && {
        style: {color},
      })}
      // Hack! undefined values reset height and width to original values
      {...(width && {width})}
      {...(height && {height})}
    />
  );
});

export default Icon;
